import { render, staticRenderFns } from "./SelectionList.vue?vue&type=template&id=145263b2&scoped=true"
import script from "./SelectionList.vue?vue&type=script&lang=js"
export * from "./SelectionList.vue?vue&type=script&lang=js"
import style0 from "./SelectionList.vue?vue&type=style&index=0&id=145263b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145263b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
